import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../../app/theme';
import config from '../../../app/config';
import utils from '../../../app/utils';
import { SnackBarType } from '../../../app/types';
import { enqueueSnackbar } from '../../../features/notifierSlice';
import LineChannelModal from './LineChannelModal';
import Button from '../../shared/Button';
import Tooltip from '../../shared/Tooltip';
import icHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';
import { getData } from '../../../features/ecBindingSlice';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 8,
      display: 'flex',
      alignItems: 'center',
      minHeight: 24,
    },
    subTitle: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 13,
      lineHeight: '18px',
      marginBottom: 12,
      color: color.$13,
    },
    input: {
      width: '100%',
    },
    error: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.46',
      color: color.$17,
      marginLeft: 12,
    },
    content: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  {
    name: 'ChannelSetting',
  },
);

const ChannelSetting = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const { data, isSaved } = useSelector(store => store.ecBinding);
  const { liffSetting } = data || {};
  const [modalState, setModalStatus] = useState(false);
  const { liffId } = liffSetting || {};

  const handleCopy = () => {
    utils.copyToClipboard(
      `${config.SHORT_SERVER_URL}/ec/${provider}/r/bind?orgId=${orgId}`,
      () => {
        dispatch(
          enqueueSnackbar({
            variant: SnackBarType.SUCCESS,
            message: t(`ecBinding:copy-success`),
          }),
        );
      },
    );
  };

  const onChannelClose = () => {
    setModalStatus(false);
  };

  return (
    <>
      <div className={classes.root}>
        <div>
          <div className={classes.title}>
            {t('ecBinding:channelSetting')}
            <Tooltip
              colortype="Light"
              light
              placement="top"
              title={t('ecBinding:channelSetting-tooltip')}
            >
              <img style={{ marginLeft: 4 }} src={icHelpCircle} alt="alert" />
            </Tooltip>
          </div>
          <div className={classes.subTitle}>
            {t('ecBinding:channelSetting-subtitle')}
          </div>
          <div className={classes.content}>
            <Button
              topic="primaryBlue"
              onClick={() => {
                setModalStatus(true);
              }}
            >
              {t('ecBinding:channelSetting-setting-btn')}
            </Button>
            {liffId && (
              <Button
                topic="primaryBlue"
                style={{ marginLeft: 8 }}
                onClick={handleCopy}
              >
                {t('ecBinding:channelSetting-copy-btn')}
              </Button>
            )}
            {isSaved && !liffId && (
              <div className={classes.error}>
                {t('ecBinding:channelSetting-error')}
              </div>
            )}
          </div>
        </div>
      </div>
      <LineChannelModal
        isOpen={modalState}
        setModalStatus={status => setModalStatus(status)}
        lineChannelInfo={liffSetting}
        getLineChannelInfo={() => dispatch(getData(orgId, provider))}
        onClose={onChannelClose}
        liffName={provider}
      />
    </>
  );
};

export default ChannelSetting;
